import { render, staticRenderFns } from "./DetailPage.vue?vue&type=template&id=d063e6e8&"
import script from "./DetailPage.vue?vue&type=script&lang=ts&"
export * from "./DetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d063e6e8')) {
      api.createRecord('d063e6e8', component.options)
    } else {
      api.reload('d063e6e8', component.options)
    }
    module.hot.accept("./DetailPage.vue?vue&type=template&id=d063e6e8&", function () {
      api.rerender('d063e6e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account-payables/amortization/DetailPage.vue"
export default component.exports